import React from 'react';
import AddToCartSnackBar from 'layouts/Product/Actions/ItemAddedSnackbar';
import Snackbar from 'components/Snackbar';
import { Device } from '@nykaa/data-layer/constants';

interface Props {
  errorType: boolean;
  message: string;
  id: string;
  closeCallback: () => void;
  device?: Device;
}

const AddToBagToast = ({
  errorType,
  message,
  id,
  closeCallback,
  device,
}: Props) => {
  if (!message) {
    return null;
  }

  return (
    <>
      {errorType ? (
        <Snackbar
          autoClose
          closeCallback={closeCallback}
          content={message}
          errorType={errorType}
          snackBarId={id}
        />
      ) : (
        <AddToCartSnackBar
          autoClose
          closeCallback={closeCallback}
          content={message}
          errorType={errorType}
          snackBarId={id}
          device={device}
        />
      )}
    </>
  );
};

export default AddToBagToast;
